import {
  WSConcernForOthersIcon,
  WSIndependenceIcon,
  WSInitiativeIcon,
  WSInnovationIcon,
  WSLeadershipIcon,
  WSPersistenceIcon,
  WSStressToleranceIcon,
} from "@eworkit/iris";

import { WorkStyleType } from "@/data/consultant-profiles/types/WorkStyleType";

export const mapWorkStyleTypeToIcon: Record<WorkStyleType, React.FC> = {
  PERFORMER: WSPersistenceIcon,
  LEADER: WSLeadershipIcon,
  TEAM_PLAYER: WSConcernForOthersIcon,
  COOL_HEADED: WSStressToleranceIcon,
  HARD_WORKING: WSInitiativeIcon,
  INDEPENDENT: WSIndependenceIcon,
  PROBLEM_SOLVER: WSInnovationIcon,
};
